import type { FaireProductEntity } from "../../entity_types/product";

export const p_zh9psmjtrc: FaireProductEntity = {
  token: "p_zh9psmjtrc",
  type: "product",
  name: "Dolomite Silk Scarf | Copper",
  brandToken: "b_3kwvjmx4",
  brandName: "Block Shop",
  imageUrl: "https://cdn.faire.com/fastly/6e0219c212c368d56e0c8f9a969a63c4e79c6e9866a492ee44ba392d3fa5831a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c4c039ab0f86a4dc2790c676ea1bc9a2cc2a291d7bd13bbfbfa186bdc409ace.jpeg",
    "https://cdn.faire.com/fastly/9fa8ba8c999359385618757235412a6c0bdc455829275003f77c01c9af747721.jpeg",
    "https://cdn.faire.com/fastly/1b02e014ccde4818d157d0e0a44a91b27a3da084e9270ef9d92f3c9ce5bc46dd.jpeg",
    "https://cdn.faire.com/fastly/36fe6ebb6c4a2d0cea3bd47d018cc6a7fb7bb45c904deb648969098c5652f31a.jpeg",
    "https://cdn.faire.com/fastly/15cf3af57a540c164dd4736cb2318fb11a5a164299e4106cd138540e363b90b8.jpeg",
    "https://cdn.faire.com/fastly/ca7fa0783870b5ceed4d7b584182ed849b72d6d7ad8023e845ae7ac80d58aa47.jpeg",
    "https://cdn.faire.com/fastly/c4faf699a5910a5e446db9fd03c5a411e9e4104a5dade76ba0d7b1476827734c.jpeg"
  ],
  priceDollars: 57.5,
  description: "Please meet our show-stopping Dolomite square scarf! Block printed to perfection on super soft silk. Inspired by the zig zagging peaks of the Italian Dolomite mountains, brought to life in copper brown and navy. Versatile & chic for every season, it can dress up a white t-shirt or add a touch of pizzazz to a little black dress. \n\n * AZO-free non-toxic dyes \n * 100% silk \n * 34 x 34 inches +/- \n * Folded hem \n * Hand block printed in Jaipur ",
  tags: [],
  msrpDollars: 115,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:57.301Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
